import { ucFirst } from "../format";
import { getSymbol } from "./transactionFormatter";

export const getTronMainInfo = (transaction) => {
  // Destructure details along with other needed fields
  const { network, hash, block, details, tx_type } = transaction;
  const tokenTransfer = details?.token_transfer;
  const nativeValue = details?.value;

  // Determine if this is a token transfer or native TRX transfer
  let coinLabel = `${ucFirst(network)} • ${getSymbol(network)}`;
  let amountData = null;
  let isTrcTen = tx_type === "tron_trc10";

  if (tokenTransfer && tokenTransfer.amount) {
    // If it's a token transfer, use the token name for Coin
    coinLabel = `${tokenTransfer.symbol || "Token"}`;

    const amountValue =
      tokenTransfer.amount / Math.pow(10, tokenTransfer.decimals || 0);
    const symbol = tokenTransfer.symbol || "";
    // Only add usdString if usd_value exists and is not "0.00"
    const usdString =
      tokenTransfer.usd_value && tokenTransfer.usd_value !== "0.00" && !isTrcTen
        ? `$\u202F${tokenTransfer.usd_value}`
        : "";
    amountData = {
      amount: `${amountValue} ${symbol}`,
      usd_value: `${usdString}`.trim(),
    };
  }
  // Check for native TRX transfer
  else if (nativeValue && nativeValue.amount) {
    const amountValue =
      nativeValue.amount / Math.pow(10, nativeValue.decimals || 0);
    const symbol = nativeValue.symbol || "TRX";
    // Only add usdString if usd_value exists and is not "0.00"
    const usdString =
      nativeValue.usd_value && nativeValue.usd_value !== "0.00" && !isTrcTen
        ? `$\u202F${nativeValue.usd_value}`
        : "";
    amountData = {
      amount: `${amountValue} ${symbol}`,
      usd_value: `${usdString}`.trim(),
    };
  }

  const mainInfoDetails = [
    {
      id: 1,
      label: "Coin",
      value: coinLabel,
    },
    {
      id: 2,
      label: "Time",
      value: block?.timestamp,
    },
    {
      id: 3,
      label: "Hash",
      value: hash,
      underline: false,
    },
  ];

  return {
    icon: network,
    title: `${ucFirst(network)} transaction`,
    subtitle: "",
    details: mainInfoDetails, // Use the updated details array
    copyValue: hash,
    amountData,
  };
};

export function tronTransactionFormatter(transaction) {
  const { date, hash, price, symbol } = transaction;
  console.log("transaction", transaction);

  // For header
  const header = {
    date,
    copyValue: hash,
  };

  // For rate banner
  const rate = {
    value: price,
    symbol,
  };

  const details = [
    {
      id: 1,
      label: "Contract",
      tooltip: "tooltip title",
      value: "TR7NH...zgjLj6t",
      copy: true,
      smartContract: true,
    },
    {
      id: 2,
      label: "Issuer",
      tooltip: "tooltip title",
      value: "THPvaUhoh2n...",
      copy: true,
    },
    {
      id: 3,
      label: "Issuing Time",
      tooltip: "tooltip title",
      value: "2019-04-16 12:41:20 (UTC)",
      copy: true,
    },
    {
      id: 4,
      label: "Decimal",
      tooltip: "tooltip title",
      value: "6",
      copy: true,
    },
    {
      id: 9,
      label: "Links",
      tooltip: "tooltip title",
      links: [
        {
          id: 1,
          label: "Official Website",
          href: "https://bitcoin.org/",
        },
        {
          id: 2,
          label: "White Paper",
          href: "https://bitcoin.org/bitcoin.pdf",
        },
        {
          id: 3,
          label: "Explorer",
          href: "https://blockchain.info/",
        },
      ],
    },
  ];

  // For main info
  const mainInfo = {
    icon: "tron", //"bitcoin", "tron", "usdt"
    title: "Tether USD (USDT)",
    subtitle: "TRC20",
    details,
    copyValue: "",
  };

  return { header, rate, mainInfo };
}

export const getTronTableData = (transaction) => {
  console.log("transaction", transaction);
  return [];
};
